import { Box, Button, InputLabel, Stack, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { labelSty, textareaSty } from "../UIElements/styles-input";
import { useTheme } from "@mui/material/styles";
import { SelectInputBgWhite } from "../UIElements/select-bgwhite";
import { useState } from "react";
import { ProfileReportModal } from "./ProfileModal";
import { useMutation } from "@tanstack/react-query";
import { apiSendFeedback } from "../../api/users";
import { useNotificationService } from "../notification";
import { LoadingButton } from "@mui/lab";

const SupportFeedback = () => {
  const isMedium = useResponsive("down", "md", "xs");
  const theme = useTheme();
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const { showNotification } = useNotificationService();
  const [state_data, setState_data] = useState({
    type: "",
    description: "",
  });

  const handleReportModal = () => {
    // open report modal
    setReportModalOpen(!reportModalOpen);
  };

  const mutation = useMutation({
    mutationFn: (fieldValues: { type: string; description: string }) =>
      apiSendFeedback(fieldValues),
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        showNotification(data?.data?.message ?? "", "success");
        setState_data({ type: "", description: "" });
      }
    },
    onError: (error) => {
      console.error("Feedback not sent", error);
      // Handle error
      showNotification("Feedback not sent", "error");
    },
  });

  const handleSubmit = () => {
    if (!state_data.type || !state_data.description) {
      showNotification(
        "Please fill in all fields to submit feedback",
        "warning",
      );
      return;
    }

    mutation.mutate(state_data);
  };
  return (
    <Box
      sx={{
        width: "100%",
        marginY: 4,
        marginX: 2,
      }}
    >
      <ProfileReportModal
        handleModal={handleReportModal}
        open={reportModalOpen}
      />
      <Box
        sx={{
          my: 4,
          display: "flex",
          flexDirection: isMedium ? "column" : "row",
          flexWrap: "wrap",
          gap: 5,
        }}
      >
        <Box sx={{ width: isMedium ? "96%" : "44%" }}>
          <Typography
            variant="h4"
            sx={{
              color: "#000E2C",
              fontWeight: 700,
              fontFamily: "Inter",
            }}
          >
            Support
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ my: 4 }}
          >
            <Typography
              sx={{
                fontFamily: "Lexend",
                fontSize: "14px",
                lineHeight: "23px",
                letterSpacing: "-0.23999999463558197px",
                color: "#000",
                fontWeight: 400,
              }}
            >
              Report an Issue
            </Typography>
            <Button
              onClick={handleReportModal}
              variant="contained"
              sx={{
                fontWeight: 700,
                fontFamily: "DM Sans",
                borderRadius: "12px",
                width: 150,
              }}
            >
              Send Report
            </Button>
          </Stack>
        </Box>

        <Box sx={{ width: isMedium ? "96%" : "44%" }}>
          <Typography
            variant="h4"
            sx={{
              color: "#000E2C",
              fontWeight: 700,
              fontFamily: "Inter",
            }}
          >
            Feedback
          </Typography>
          <Stack sx={{ my: 3 }}>
            <SelectInputBgWhite
              label={"Feedback Type"}
              value={state_data.type}
              onChange={(e) =>
                setState_data((prev) => ({ ...prev, type: e.target.value }))
              }
              options={[
                { value: "Great", label: "Great" },
                { value: "Excellent", label: "Excellent" },
                { value: "Disappointing", label: "Disappointing" },
                { value: "Bad", label: "Bad" },
                { value: "Okay", label: "Okay" },
                { value: "Alright", label: "Alright" },
                { value: "Efficient", label: "Efficient" },
              ]}
            />

            <Stack sx={{ pl: 2 }}>
              <InputLabel sx={labelSty}>Description</InputLabel>
              <textarea
                className="text-area"
                style={{
                  ...textareaSty,
                  background: theme.palette.common.white,
                }}
                rows={4}
                value={state_data?.description}
                onChange={(e: any) =>
                  setState_data((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                placeholder={""}
              />
            </Stack>
            <LoadingButton
              onClick={handleSubmit}
              variant="contained"
              sx={{
                width: "100%",
                ml: 2,
                borderRadius: 2,
                mt: 4,
                fontWeight: 700,
              }}
            >
              Send
            </LoadingButton>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default SupportFeedback;
